module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-white-30b5b9debe89909d746f512dcbd72a31.png";